module.exports = __webpack_public_path__ + "static/portfolio_gallery_19-f2dab14976e1f81d42c58429127183bf.jpg";